var url = new URL(location);
url.searchParams.delete('add-to-cart');
history.replaceState(null, null, url)

jQuery(document).ready(function ($) {

    $('#CalcOptionSelect').on('change', function () {
        var selected = $(this).find('option:selected');
        console.log(selected);
    })

    //Gather up the defaults for use when we change the variant selector
    var initPriceRange = $('.lead-price').text();
    $('#initPriceRange').val(initPriceRange);
    var initPricePerPack = $('.sub-price').text();
    $('#initPricePerPack').val(initPricePerPack)
    var initSKU = $('.sku').text();
    $('#initSKU').val(initSKU);

    // Non-flooring variable products use Woo's own attribute dropdowns rather
    // than #CalcOptionSelect, and their SKU line starts blank (see
    // woodpecker_pdp_sku_line in inc/wooHooks.php). Woo fires found_variation
    // once every dropdown is set and matches a variation, and hide_variation
    // whenever the selection is incomplete or reset.
    if (!$('#CalcOptionSelect').length) {
        $('.variations_form')
            .on('found_variation', function (event, variation) {
                $('.product-meta-row__sku').text(variation.sku ? 'SKU: ' + variation.sku : '');
            })
            .on('hide_variation reset_data', function () {
                $('.product-meta-row__sku').text('');
            });
    }


    sessionStorage.nopacks = 0;
    var theForm = document.forms["packcalculator"];
    var price = $('#priceToBePickedUp').val();
    var packsize = $('#packSizeToBePickedUp').val();
    var productType = $('#productTypeToBePickedUp').val();
    var productId = $('#productIdToBePickedUp').val();

    function setPackTotal(quant) {
        sessionStorage.setItem("nopacks", quant);
        var wastage = 1;
        if (jQuery("#CalcOptionSelect").length) {
            //Variant Product
            var calcPrice = parseFloat(jQuery("#CalcOptionSelect").children("option:selected").data("price")) * (quant * parseFloat(jQuery("#CalcOptionSelect").children("option:selected").data("packsize")));
            //Load To Page
            document.getElementById("totalPrice").innerHTML = "<p class='actual'>£" + calcPrice.toFixed(2).toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,") + "</p>";
            jQuery(".packQuantity").val(quant);
            //Calculate Sq Meterage from Pack number
            var roomAreaCalc = ((quant * parseFloat(jQuery("#CalcOptionSelect").children("option:selected").data("packsize"))) / 1.1);
            jQuery("#roomarea").val(Math.round(roomAreaCalc * 10) / 10);
            var singleDim = Math.sqrt(Math.round(roomAreaCalc * 10) / 10);
            jQuery("#roomlength").val(Math.round(singleDim * 10) / 10);
            jQuery("#roomwidth").val(Math.round(singleDim * 10) / 10);

            //Set Sqaure Meterage
            var totalOrderQty = quant * parseFloat(jQuery("#CalcOptionSelect").children("option:selected").data("packsize"));
            $('#totalOrderQty').text('(' + Math.round(totalOrderQty * 100) / 100 + 'm2)')
        } else {
            //Single Product
            var calcPrice = (quant * (price * 1));
            //Load To Page
            document.getElementById("totalPrice").innerHTML = "<p class='actual'>£" + calcPrice.toFixed(2).toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,") + "</p>";
            jQuery(".packQuantity").val(quant);
            var roomAreaCalc = ((quant * packsize) / wastage);
            jQuery("#roomarea").val(Math.round(roomAreaCalc * 10) / 10);
            var singleDim = Math.sqrt(Math.round(roomAreaCalc * 10) / 10);
            jQuery("#roomlength").val(Math.round(singleDim * 10) / 10);
            jQuery("#roomwidth").val(Math.round(singleDim * 10) / 10);

            //Set Sqaure Meterage
            var totalOrderQty = quant * packsize;
            $('#totalOrderQty').text('(' + Math.round(totalOrderQty * 100) / 100 + 'm2)')
        }
    }

    function getTotal() {
        var wastage = 1;
        //Calculate Room Area
        // The length / width / area inputs are UK-only — inc/packSizeCalculator.php
        // omits them on the US site, where the panel carries an appointment link
        // instead of a basket. Reading .value off the missing #roomarea threw here,
        // which aborted the whole function and left the US price, SKU and stock
        // frozen on every option change. Everything below this line works without
        // a room area, so fall back to 0 rather than bailing.
        var roomareaEl = document.getElementById("roomarea");
        var roomarea = ((roomareaEl ? roomareaEl.value : 0) * wastage);
        var select = $("#CalcOptionSelect");
        if (jQuery("#CalcOptionSelect").length) {

            //Change the top level price display on change
            price = parseFloat(select.children("option:selected").data("price"));
            var packSize = parseFloat(select.children("option:selected").data("packsize"));
            var sku = select.children("option:selected").data("sku");
            var stock = select.children("option:selected").data("stock");
            var pricePerPack = parseFloat(price * packSize);

            // Match the form the page is rendered with (see
            // inc/displayPriceAndPackSize.php): "£87.00/m²" for the headline and
            // the pack size carrying its own unit. Picking a variation used to
            // drop the slash and the m² off the pack size, so the price changed
            // shape as soon as the shopper chose an option.
            if (!isNaN(price)) {
                $('.lead-price').html("£" + price.toFixed(2) + "/m²");
            } else {
                $('.lead-price').html($('#initPriceRange').val())
            }
            if (!isNaN(packSize)) {
                $('.sub-price').html("£" + pricePerPack.toFixed(2) + " per pack <span class='tiny-text'>(" + packSize + "m²)</span>")
            } else {
                $('.sub-price').html($('#initPricePerPack').val())
            }
            if (sku !== undefined) {
                $('.sku').html('SKU: ' + sku);
            } else {
                $('.sku').html($('#initSKU').val());
            }

            if(stock !== undefined){
                if(stock < 1){
                    $('.stock').html('Out of Stock');
                    $('.addToBsktBtn').prop('disabled', true)
                } else {
                    // Matches woodpecker_pdp_stock_text() in inc/wooHooks.php —
                    // picking a plank must not change the wording of the line.
                    $('.stock').html('In Stock: ' + stock);
                    $('.addToBsktBtn').prop('disabled', false)
                }
            } else {
                $('.stock').html('');
            }


            //Variant Product
            var nopacks = Math.ceil(roomarea / parseFloat(jQuery("#CalcOptionSelect").children("option:selected").data("packsize")));
            sessionStorage.setItem("nopacks", nopacks);
            var calcPrice = parseFloat(jQuery("#CalcOptionSelect").children("option:selected").data("price")) * (nopacks * parseFloat(jQuery("#CalcOptionSelect").children("option:selected").data("packsize")));
            //Load To Page
            document.getElementById("totalPrice").innerHTML = "<p class='actual'>£" + calcPrice.toFixed(2).toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,") + "</p>";
            jQuery(".packQuantity").val(nopacks);
            var totalOrderQty = nopacks * parseFloat(jQuery("#CalcOptionSelect").children("option:selected").data("packsize"));
            $('#totalOrderQty').text('(' + Math.round(totalOrderQty * 100) / 100 + 'm2)')
            if (nopacks > 0) {
                $('.totals').slideDown();
                $('.addToBsktBtn').prop('disabled', false)
            } else {
                $('.totals').slideUp()
                $('.addToBsktBtn').prop('disabled', true)
            }
        } else {
            //Single Product
            var ppsqm = ((price * 1) / packsize);
            var nopacks = Math.ceil(roomarea / packsize);
            sessionStorage.setItem("nopacks", nopacks);
            var calcPrice = (nopacks * (price * 1));
            //Load To Page
            document.getElementById("totalPrice").innerHTML = "<p class='actual'>£" + calcPrice.toFixed(2).toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,") + "</p>";
            jQuery(".packQuantity").val(nopacks);
            var totalOrderQty = nopacks * packsize;
            $('#totalOrderQty').text('(' + Math.round(totalOrderQty * 100) / 100 + 'm2)')
            if (nopacks > 0) {
                $('.totals').slideDown();
                $('.addToBsktBtn').prop('disabled', false)
            } else {
                $('.totals').slideUp()
                $('.addToBsktBtn').prop('disabled', true)
            }
        }
    }


    //Add To Basket From Calculations Tool Button Functions.
    jQuery("#AddSingleToBasketfromCalc").on("click", function (event) {
        // alert($("#AddSingleToBasketfromCalc").data("linkref"));
        window.location.href = $("#AddSingleToBasketfromCalc").data("linkref") + '&quantity=' + sessionStorage.getItem("nopacks");
        sessionStorage.setItem("nopacks", 0);
    });
    jQuery("#AddToBasketfromCalc").on("click", function (event) {
        if ($("#CalcOptionSelect").length) {
            //alert( $("#CalcOptionSelect").children("option:selected").val() );
            //alert(sessionStorage.getItem ("nopacks"));
            window.location.href = '?add-to-cart=' + $("#CalcOptionSelect").children("option:selected").val() + '&quantity=' + sessionStorage.getItem("nopacks");
            var url = new URL(location);
            url.searchParams.delete('message');
            history.replaceState(null, null, url)
            sessionStorage.setItem("nopacks", 0);
        }
    });
    $('#requestSample').on('click', function () {
        if (productType === 'variable') {
            var var_id = $('#CalcOptionSelect').find(':selected').val();
            if(var_id === ''){
                alert('Please Select an Option')
                return;
            }
            $('<form method="POST"/>')
                .append($('<input type="hidden" name="quantity" value="1">' +
                    '<input type="hidden" name="add_sample" value=""/>' +
                    '<input type="hidden" name="variation_id" value="' + var_id + '"/>' +
                    '<input type="hidden" name="add-to-cart" value="' + productId + '"/>'))
                .appendTo($(document.body)) //it has to be added somewhere into the <body>
                .submit();
        } else {
            $('<form method="POST"/>')
                .append($('<input type="hidden" name="quantity" value="1">' +
                    '<input type="hidden" name="add_sample" value=""/>'))
                .appendTo($(document.body)) //it has to be added somewhere into the <body>
                .submit();
        }

    })


    $(".roomlength, .roomwidth").on('change keyup', function () {
        var val1 = +$(".roomlength").val();
        var val2 = +$(".roomwidth").val();
        $("#roomarea").val(Math.round(val1 * val2 * 100) / 100);
        //Call Recalculation
        getTotal();
        //$( "#formCalculateButton" ).click();
    });
    jQuery("#CalcOptionSelect").on("change", function (event) {
        //Call Click On Calculate Button
        getTotal();
        //$( "#formCalculateButton" ).click();
    });
    jQuery("#roomarea").on('change keyup', function () {
        //Call Click On Calculate Button
        getTotal();
        //$( "#formCalculateButton" ).click();
    });
    jQuery(".packQuantity").on('change keyup', function () {
        //Call Click On Calculate Button
        setPackTotal(+$(".packQuantity").val());
        if($(this).val() > 0){
            $('.addToBsktBtn').prop('disabled', false)
        } else {
            $('.addToBsktBtn').prop('disabled', true)
        }
    });
});

/*
 * 2026 reskin: the swatch row that used to sit here set #CalcOptionSelect from a
 * click on a plank tile. The tiles are now a content-driven illustration of the
 * plank styles a floor comes in and deliberately select nothing — see
 * inc/plankStyles.php — so their popover handler lives with the rest of the page
 * furniture in assets/js/scripts.js, not in the calculator.
 *
 * What did belong to the dropdown all along, and stays here: the stock / price row
 * is marked empty server-side when it renders with nothing in it, which drops the
 * design's rule rather than drawing a line under a gap. Choosing an option fills
 * the stock line in, so the rule has to come back.
 */
jQuery(document).ready(function ($) {
    var $select = $('#CalcOptionSelect');
    var $metaRow = $('.product-meta-row');

    if (!$select.length || !$metaRow.length) {
        return;
    }

    $select.on('change', function () {
        // Measured rather than read as text: the US site hides .stock outright in
        // _us-styles.scss, so it can hold a stock count and still take up no room.
        // A text check would put the rule back over an empty gap there.
        var hasVisibleContent = $metaRow.children().filter(function () {
            return this.offsetHeight > 0 || this.offsetWidth > 0;
        }).length > 0;

        $metaRow.toggleClass('product-meta-row--empty', !hasVisibleContent);
    });
});
